import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  sectionContainer: {
    marginBottom: 30,
    position: 'relative'
  },
  sectionHeader: {
    lineHeight: '28px',
    marginBottom: 22,
    [theme.breakpoints.down('lg')]: {
      //display: 'none'
    }
  },
  sectionHeaderWithSubHeader: {
    marginBottom: 8,
  },
  sectionSubHeader: {
    lineHeight: '28px',
    marginBottom: 22,
    fontWeight: 450,
    [theme.breakpoints.down('lg')]: {
      //display: 'none'
    }
  },
  sectionContent: {
    background: '#FFF',
    position: 'relative',
  },
  sectionContentPadded: {
    padding: 20
  },
  sectionContentShadow: {
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.08)', // This wass
  },
  link: {
    position: 'absolute',
    right: 0,
    top: 8,
    height: '18px',
    cursor: 'pointer',
    fontWeight: 500,
    lineHeight: '1.13',
    color: '#2d91e9',
    padding: '0 10px 0 0',
    textDecoration: 'none'
  },
  dropdownWrapper: {
    width: '260px',
    position: 'absolute',
    right: 0,
    top: -10,
    '@media(max-width: 480px)': {
      position: 'relative',
      width: '100%',
      right: 0,
      top: 0,
      marginBottom: 20,
      '& > div': {
        width: '100%',
      },
    },
  }
});
